<template>
  <div>
    <h1>In component</h1>
    <h2>id: {{ compId }}</h2>
    <h3>text: {{ compText }}</h3>
    <v-text-field
    outlined
    placeholder="compValue"
      v-model="compValue"
      @input="valueChangedMethodInComponent"
    ></v-text-field>
    -------------------------------
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: "ComponentTest",
  //   props: ["myProp"], //Single prop
  props: {
    
      id: Number,
      text: String,

  },
  data() {
    return {
      compId: this.id,
      compText: this.text,
      compValue: String
    };
  },
  created (){
      this.compValue = null;
  },
  methods: {
      valueChangedMethodInComponent() {
    //   this.model = null;
      this.$emit("valueChangedMethodInComponent", this.compValue);
      //In Parent, se Test.vue: <DynamicComponentTest v-bind:id="post.id" v-bind:text="post.text" @valueChangedMethodInComponent="setValueMethodInView"></DynamicComponentTest>
      //In Parent, se Test.vue - sende helt object <DynamicComponentTest v-bind="post" @valueChangedMethodInComponent="setValueMethodInView"></DynamicComponentTest>
    }
  }
};
</script>